// TDHP Balance Sheet Template Structure
// Turkish Uniform Chart of Accounts (TDHP) compliant balance sheet template

// TDHP Template Structure - Exact line items and order
export const TDHP_TEMPLATE = {
  report: "BILANCO",
  sections: [
    {
      title: "A K T İ F L E R",
      blocks: [
        {
          blockCode: "I",
          blockTitle: "DÖNEN VARLIKLAR",
          groups: [
            {
              groupTitle: "A HAZIR DEĞERLER",
              lines: [
                { code: "100", label: "KASA", contra: false },
                { code: "101", label: "ALINAN ÇEKLER", contra: false },
                { code: "102", label: "BANKA", contra: false },
                { code: "103", label: "VERİLEN ÇEKLER VE ÖDEME EMİRLERİ", contra: true },
                { code: "108", label: "DİĞER HAZIR DEĞERLER", contra: false }
              ]
            },
            {
              groupTitle: "B MENKUL KIYMETLER",
              lines: [
                { code: "110", label: "HİSSE SENETLERİ", contra: false },
                { code: "111", label: "ÖZEL KESİM TAHVİL, SENET VE BONOLARI", contra: false },
                { code: "112", label: "KAMU KESİMİ TAHVİL, SENET VE BONOLARI", contra: false },
                { code: "118", label: "DİĞER MENKUL KIYMETLER", contra: false },
                { code: "119", label: "MENKUL KIYMETLER DEĞER DÜŞÜKLÜĞÜ KARŞILIĞI", contra: true }
              ]
            },
            {
              groupTitle: "C TİCARİ ALACAKLAR",
              lines: [
                { code: "120", label: "ALICILAR", contra: false },
                { code: "121", label: "ALACAK SENETLERİ", contra: false },
                { code: "122", label: "ALACAK SENETLERİ REESKONTU", contra: true },
                { code: "123", label: "KAZANILMAMIŞ FİNANSAL KİRALAMA FAİZ GELİRLERİ", contra: false },
                { code: "126", label: "VERİLEN DEPOZİTO VE TEMİNATLAR", contra: false },
                { code: "127", label: "DİĞER TİCARİ ALACAKLAR", contra: false },
                { code: "128", label: "ŞÜPHELİ TİCARİ ALACAKLAR", contra: false },
                { code: "129", label: "ŞÜPHELİ TİCARİ ALACAKLAR KARŞILIĞI", contra: true }
              ]
            },
            {
              groupTitle: "D DİĞER ALACAKLAR",
              lines: [
                { code: "131", label: "ORTAKLARDAN ALACAKLAR", contra: false },
                { code: "132", label: "İŞTİRAKLERDEN ALACAKLAR", contra: false },
                { code: "133", label: "BAĞLI ORTAKLIKLARDAN ALACAKLAR", contra: false },
                { code: "135", label: "PERSONELDEN ALACAKLAR", contra: false },
                { code: "136", label: "DİĞER ÇEŞİTLİ ALACAKLAR", contra: false },
                { code: "137", label: "DİĞER ALACAK SENETLERİ REESKONTU", contra: true },
                { code: "138", label: "ŞÜPHELİ DİĞER ALACAKLAR", contra: false },
                { code: "139", label: "ŞÜPHELİ DİĞER ALACAKLAR KARŞILIĞI", contra: true }
              ]
            },
            {
              groupTitle: "E STOKLAR",
              lines: [
                { code: "150", label: "İLK MADDE VE MALZEME", contra: false },
                { code: "151", label: "YARI MAMULLER - ÜRETİM", contra: false },
                { code: "152", label: "MAMULLER", contra: false },
                { code: "153", label: "TİCARİ MALLAR", contra: false },
                { code: "157", label: "DİĞER STOKLAR", contra: false },
                { code: "158", label: "STOK DEĞER DÜŞÜKLÜĞÜ KARŞILIĞI", contra: true },
                { code: "159", label: "VERİLEN SİPARİŞ AVANSLARI", contra: false }
              ]
            },
            {
              groupTitle: "F YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ",
              lines: [
                { code: "170", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "171", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "172", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "173", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "174", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "175", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "176", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "177", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "178", label: "YILLARA YAYGIN İNŞAAT VE ONARIM MALİYETLERİ", contra: false },
                { code: "179", label: "TAŞERONLARA VERİLEN AVANSLAR", contra: false }
              ]
            },
            {
              groupTitle: "G GELECEK AYLARA AİT GİDERLER VE GELİR TAHAKKUKLARI",
              lines: [
                { code: "180", label: "GELECEK AYLARA AİT GİDERLER", contra: false },
                { code: "181", label: "GELİR TAHAKKUKLARI", contra: false }
              ]
            },
            {
              groupTitle: "H DİĞER DÖNEN VARLIKLAR",
              lines: [
                { code: "190", label: "DEVREDEN KDV", contra: false },
                { code: "191", label: "İNDİRİLECEK KATMA DEĞER VERGİSİ", contra: false },
                { code: "192", label: "DİĞER KATMA DEĞER VERGİSİ", contra: false },
                { code: "193", label: "PEŞİN ÖDENEN VERGİLER VE FONLAR", contra: false },
                { code: "195", label: "İŞ AVANSLARI", contra: false },
                { code: "196", label: "PERSONEL AVANSLARI", contra: false },
                { code: "197", label: "SAYIM VE TESELLÜM NOKSANLARI", contra: false },
                { code: "198", label: "DİĞER ÇEŞİTLİ DÖNEN VARLIKLAR", contra: false },
                { code: "199", label: "DİĞER DÖNEN VARLIKLAR KARŞILIĞI", contra: true }
              ]
            }
          ]
        },
        {
          blockCode: "II",
          blockTitle: "DURAN VARLIKLAR",
          groups: [
            {
              groupTitle: "A TİCARİ ALACAKLAR",
              lines: [
                { code: "220", label: "ALICILAR", contra: false },
                { code: "221", label: "ALACAK SENETLERİ", contra: false },
                { code: "222", label: "ALACAK SENETLERİ REESKONTU", contra: true },
                { code: "226", label: "VERİLEN DEPOZİTO VE TEMİNATLAR", contra: false },
                { code: "229", label: "ŞÜPHELİ ALACAKLAR KARŞILIĞI", contra: true }
              ]
            },
            {
              groupTitle: "B DİĞER ALACAKLAR",
              lines: [
                { code: "231", label: "ORTAKLARDAN ALACAKLAR", contra: false },
                { code: "232", label: "İŞTİRAKLERDEN ALACAKLAR", contra: false },
                { code: "233", label: "BAĞLI ORTAKLIKLARDAN ALACAKLAR", contra: false },
                { code: "236", label: "DİĞER ÇEŞİTLİ ALACAKLAR", contra: false },
                { code: "237", label: "DİĞER ALACAK SENETLERİ REESKONTU", contra: true },
                { code: "239", label: "ŞÜPHELİ DİĞER ALACAKLAR KARŞILIĞI", contra: true }
              ]
            },
            {
              groupTitle: "C MALİ DURAN VARLIKLAR",
              lines: [
                { code: "240", label: "BAĞLI MENKUL KIYMETLER", contra: false },
                { code: "241", label: "BAĞLI MENKUL KIYMETLER DEĞER DÜŞÜKLÜĞÜ KARŞILIĞI", contra: true },
                { code: "242", label: "İŞTİRAKLER", contra: false },
                { code: "244", label: "İŞTİRAKLER SERMAYE PAYLARI DEĞER DÜŞÜKLÜĞÜ", contra: true },
                { code: "245", label: "BAĞLI ORTAKLIKLAR", contra: false },
                { code: "247", label: "BAĞLI ORTAKLIKLAR SERMAYE PAYLARI DEĞER DÜŞÜKLÜĞÜ", contra: true },
                { code: "248", label: "DİĞER MALİ DURAN VARLIKLAR", contra: false },
                { code: "249", label: "DİĞER MALİ DURAN VARLIKLAR DEĞER DÜŞÜKLÜĞÜ", contra: true }
              ]
            },
            {
              groupTitle: "D MADDİ DURAN VARLIKLAR",
              lines: [
                { code: "250", label: "ARAZİ VE ARSALAR", contra: false },
                { code: "251", label: "YER ALTI VE YER ÜSTÜ DÜZENLERİ", contra: false },
                { code: "252", label: "BİNALAR", contra: false },
                { code: "253", label: "TESİS, MAKİNE VE CİHAZLAR", contra: false },
                { code: "254", label: "TAŞITLAR", contra: false },
                { code: "255", label: "DEMİRBAŞLAR", contra: false },
                { code: "256", label: "DİĞER MADDİ DURAN VARLIKLAR", contra: false },
                { code: "257", label: "BİRİKMİŞ AMORTİSMANLAR", contra: true },
                { code: "258", label: "YAPILMAKTA OLAN YATIRIMLAR", contra: false },
                { code: "259", label: "VERİLEN AVANSLAR", contra: false }
              ]
            },
            {
              groupTitle: "E MADDİ OLMAYAN DURAN VARLIKLAR",
              lines: [
                { code: "260", label: "HAKLAR", contra: false },
                { code: "261", label: "ŞEREFİYE", contra: false },
                { code: "262", label: "KURULUŞ VE ÖRGÜTLENME GİDERLERİ", contra: false },
                { code: "263", label: "ARAŞTIRMA VE GELİŞTİRME GİDERLERİ", contra: false },
                { code: "264", label: "ÖZEL MALİYETLER", contra: false },
                { code: "267", label: "DİĞER MADDİ OLMAYAN DURAN VARLIKLAR", contra: false },
                { code: "268", label: "BİRİKMİŞ AMORTİSMANLAR", contra: true },
                { code: "269", label: "VERİLEN AVANSLAR", contra: false }
              ]
            },
            {
              groupTitle: "F GELECEK YILLARA AİT GİDERLER VE GELİR TAHAKKUKLARI",
              lines: [
                { code: "280", label: "GELECEK YILLARA AİT GİDERLER", contra: false },
                { code: "281", label: "GELİR TAHAKKUKLARI", contra: false }
              ]
            },
            {
              groupTitle: "G DİĞER DURAN VARLIKLAR",
              lines: [
                { code: "296", label: "PEŞİN ÖDENEN GİDERLER", contra: false }
              ]
            }
          ]
        }
      ]
    },
    {
      title: "P A S İ F L E R",
      blocks: [
        {
          blockCode: "I",
          blockTitle: "KISA VADELİ YABANCI KAYNAKLAR",
          groups: [
            {
              groupTitle: "A MALİ BORÇLAR",
              lines: [
                { code: "300", label: "BANKA KREDİLERİ", contra: false },
                { code: "301", label: "FİNANSAL KİRALAMA İŞLEMLERİNDEN BORÇLAR", contra: false },
                { code: "303", label: "UZUN VADELİ KREDİLERİN ANAPARA TAKSİTLERİ VE FAİZLERİ", contra: false },
                { code: "304", label: "TAHVİL ANAPARA BORÇ, TAKSİT VE FAİZLERİ", contra: false },
                { code: "309", label: "DİĞER MALİ BORÇLAR", contra: false }
              ]
            },
            {
              groupTitle: "B TİCARİ BORÇLAR",
              lines: [
                { code: "320", label: "SATICILAR", contra: false },
                { code: "321", label: "BORÇ SENETLERİ", contra: false },
                { code: "322", label: "BORÇ SENETLERİ REESKONTU", contra: true },
                { code: "326", label: "ALINAN DEPOZİTO VE TEMİNATLAR", contra: false },
                { code: "329", label: "DİĞER TİCARİ BORÇLAR", contra: false }
              ]
            },
            {
              groupTitle: "C DİĞER BORÇLAR",
              lines: [
                { code: "331", label: "ORTAKLARA BORÇLAR", contra: false },
                { code: "332", label: "İŞTİRAKLERE BORÇLAR", contra: false },
                { code: "333", label: "BAĞLI ORTAKLIKLARA BORÇLAR", contra: false },
                { code: "335", label: "PERSONELE BORÇLAR", contra: false },
                { code: "336", label: "DİĞER ÇEŞİTLİ BORÇLAR", contra: false },
                { code: "337", label: "DİĞER BORÇ SENETLERİ REESKONTU", contra: true }
              ]
            },
            {
              groupTitle: "D ALINAN AVANSLAR",
              lines: [
                { code: "340", label: "ALINAN SİPARİŞ AVANSLARI", contra: false },
                { code: "349", label: "ALINAN DİĞER AVANSLAR", contra: false }
              ]
            },
            {
              groupTitle: "E GELECEK AYLARA AİT GELİRLER VE GİDER TAHAKKUKLARI",
              lines: [
                { code: "380", label: "GELECEK AYLARA AİT GELİRLER", contra: false },
                { code: "381", label: "GİDER TAHAKKUKLARI", contra: false }
              ]
            },
            {
              groupTitle: "F ÖDENECEK VERGİ VE DİĞER YÜKÜMLÜLÜKLER",
              lines: [
                { code: "360", label: "ÖDENECEK VERGİ VE FONLAR", contra: false },
                { code: "361", label: "ÖDENECEK SOSYAL GÜVENLİK KESİNTİLERİ", contra: false },
                { code: "368", label: "VADESİ GEÇMİŞ ERTELENMİŞ VEYA TAKSİTLENDİRİLMİŞ VERGİ VE YÜKÜMLÜLÜKLER", contra: false },
                { code: "369", label: "ÖDENECEK DİĞER YÜKÜMLÜLÜKLER", contra: false }
              ]
            },
            {
              groupTitle: "G BORÇ VE GİDERLER KARŞILIKLARI",
              lines: [
                { code: "370", label: "DÖNEM KARI VERGİ VE DİĞER YASAL YÜKÜMLÜLÜKLER KARŞILIKLARI", contra: false }
              ]
            },
            {
              groupTitle: "H DİĞER KISA VADELİ YABANCI KAYNAKLAR",
              lines: [
                { code: "390", label: "DİĞER KISA VADELİ YABANCI KAYNAKLAR", contra: false },
                { code: "391", label: "HESAPLANAN KDV", contra: false },
                { code: "397", label: "SAYIM VE TESELLÜM FAZLALARI", contra: false }
              ]
            }
          ]
        },
        {
          blockCode: "II",
          blockTitle: "UZUN VADELİ YABANCI KAYNAKLAR",
          groups: [
            {
              groupTitle: "A MALİ BORÇLAR",
              lines: [
                { code: "400", label: "MALİ BORÇLAR (UZUN VADELİ)", contra: false }
              ]
            },
            {
              groupTitle: "B TİCARİ BORÇLAR (UZUN VADELİ)",
              lines: [
                { code: "420", label: "SATICILAR (UZUN VADELİ)", contra: false },
                { code: "421", label: "BORÇ SENETLERİ (UZUN VADELİ)", contra: false }
              ]
            },
            {
              groupTitle: "C DİĞER BORÇLAR (UZUN VADELİ)",
              lines: [
                { code: "430", label: "DİĞER BORÇLAR (UZUN VADELİ)", contra: false },
                { code: "431", label: "BORÇ SENETLERİ", contra: false }
              ]
            },
            {
              groupTitle: "D BORÇ VE GİDER KARŞILIKLARI (UZUN VADELİ)",
              lines: [
                { code: "472", label: "BORÇ VE GİDER KARŞILIKLARI (UZUN VADELİ)", contra: false },
                { code: "479", label: "DİĞER KARŞILIKLAR", contra: false }
              ]
            },
            {
              groupTitle: "E GELECEK YILLARA AİT GELİRLER VE GİDER TAHAKKUKLARI",
              lines: [
                { code: "480", label: "GELECEK YILLARA AİT GELİRLER", contra: false },
                { code: "481", label: "GİDER TAHAKKUKLARI", contra: false }
              ]
            },
            {
              groupTitle: "F DİĞER UZUN VADELİ YABANCI KAYNAKLAR",
              lines: [
                { code: "490", label: "DİĞER UZUN VADELİ YABANCI KAYNAKLAR", contra: false }
              ]
            }
          ]
        },
        {
          blockCode: "III",
          blockTitle: "ÖZKAYNAKLAR",
          groups: [
            {
              groupTitle: "A ÖDENMİŞ SERMAYE",
              lines: [
                { code: "500", label: "SERMAYE", contra: false },
                { code: "501", label: "ÖDENMEMİŞ SERMAYE", contra: true },
                { code: "502", label: "SERMAYE DÜZELTMESİ OLUMLU FARKLARI", contra: false },
                { code: "503", label: "SERMAYE DÜZELTMESİ OLUMSUZ FARKLARI", contra: true }
              ]
            },
            {
              groupTitle: "B SERMAYE YEDEKLERİ",
              lines: [
                { code: "520", label: "HİSSE SENETLERİ İHRAÇ PRİMLERİ", contra: false },
                { code: "521", label: "HİSSE SENEDİ İPTAL KARLARI", contra: false },
                { code: "522", label: "M.D.V. YENİDEN DEĞERLEME ARTIŞLARI", contra: false },
                { code: "523", label: "İŞTİRAKLER YENİDEN DEĞERLEME ARTIŞLARI", contra: false },
                { code: "529", label: "DİĞER SERMAYE YEDEKLERİ", contra: false }
              ]
            },
            {
              groupTitle: "C KAR YEDEKLERİ",
              lines: [
                { code: "540", label: "YASAL YEDEKLER", contra: false },
                { code: "541", label: "STATÜ YEDEKLERİ", contra: false },
                { code: "542", label: "OLAĞANÜSTÜ YEDEKLER", contra: false },
                { code: "549", label: "DİĞER KAR YEDEKLERİ", contra: false }
              ]
            },
            {
              groupTitle: "D GEÇMİŞ YILLAR KARLARI / ZARARLARI",
              lines: [
                { code: "570", label: "GEÇMİŞ YILLAR KARLARI", contra: false },
                { code: "580", label: "GEÇMİŞ YILLAR ZARARLARI", contra: true }
              ]
            },
            {
              groupTitle: "F DÖNEM NET KARI (ZARARI)",
              lines: [
                { code: "590", label: "DÖNEM NET KARI", contra: false },
                { code: "591", label: "DÖNEM NET ZARARI", contra: true }
              ]
            }
          ]
        }
      ]
    }
  ]
};

// Helper function to extract kebir code from account code
export const getKebirCode = (accountCode) => {
  if (!accountCode || typeof accountCode !== 'string') {
    return null;
  }
  
  // Remove non-digit characters and get first 3 digits
  const digitsOnly = accountCode.replace(/[^0-9]/g, '');
  return digitsOnly.substring(0, 3);
};

// Helper function to aggregate account balances by kebir code
export const aggregateByKebir = (accounts) => {
  
  if (!Array.isArray(accounts)) {
    return [];
  }
  
  const kebirMap = {};
  
  accounts.forEach(account => {
    const kebirCode = getKebirCode(account.AccountCode);
    if (!kebirCode) return;
    
    if (!kebirMap[kebirCode]) {
      kebirMap[kebirCode] = {
        code: kebirCode,
        balance: 0,
        accountName: account.AccountName || `Hesap ${kebirCode}`,
        contra: false
      };
    }
    
    // Use display_balance if available (backend already handles signed balance conversion)
    // Otherwise fall back to Balance or Amount
    const balance = parseFloat(account.display_balance || account.Balance || account.Amount || 0);
    kebirMap[kebirCode].balance += balance;
  });
  
  return Object.values(kebirMap);
};

// Helper function to calculate line amount with proper signed balance handling
export const calculateLineAmount = (kebirAccounts, lineCode, isContra) => {
  if (!Array.isArray(kebirAccounts)) {
    return 0;
  }
  
  const account = kebirAccounts.find(acc => acc.code === lineCode);
  if (!account) return 0;
  
  // Backend already provides display_balance with proper signed balance conversion
  // So we can use the balance directly
  let signedBalance = account.balance;
  
  // Handle contra accounts (show as negative)
  if (isContra) {
    signedBalance = -Math.abs(signedBalance);
  }
  
  return signedBalance;
};

// Helper function to calculate group subtotal
export const calculateGroupSubtotal = (kebirAccounts, lines) => {
  return lines.reduce((subtotal, line) => {
    return subtotal + calculateLineAmount(kebirAccounts, line.code, line.contra);
  }, 0);
};

// Helper function to calculate block subtotal
export const calculateBlockSubtotal = (kebirAccounts, groups) => {
  return groups.reduce((subtotal, group) => {
    return subtotal + calculateGroupSubtotal(kebirAccounts, group.lines);
  }, 0);
};

// Main function to generate TDHP balance sheet data
export const generateTDHPBalanceSheet = (accounts, hideZeroLines = false) => {
  if (!Array.isArray(accounts)) {
    accounts = [];
  }
  
  // Aggregate accounts by kebir code
  const kebirAccounts = aggregateByKebir(accounts);
  
  // Create kebir map for quick lookup
  const kebirMap = {};
  if (Array.isArray(kebirAccounts)) {
    kebirAccounts.forEach(account => {
      kebirMap[account.code] = account;
    });
  }
  
  // Process template structure
  const processedTemplate = JSON.parse(JSON.stringify(TDHP_TEMPLATE));
  
  // Add current date
  processedTemplate.asOf = new Date().toISOString();
  processedTemplate.currency = "TRY";
  processedTemplate.hideZeroLines = hideZeroLines;
  
  // Process each section
  processedTemplate.sections.forEach(section => {
    section.blocks.forEach(block => {
      block.groups.forEach(group => {
        // Process each line in the group
        group.lines.forEach(line => {
          const amount = calculateLineAmount(kebirAccounts, line.code, line.contra);
          line.amount = amount;
          
          // Hide zero lines if requested
          if (hideZeroLines && Math.abs(amount) < 0.01) {
            line.hidden = true;
          }
        });
        
        // Calculate group subtotal
        group.subtotal = calculateGroupSubtotal(kebirAccounts, group.lines);
      });
      
      // Calculate block subtotal
      block.blockSubtotal = calculateBlockSubtotal(kebirAccounts, block.groups);
    });
  });
  
  // Calculate totals
  const assetsTotal = processedTemplate.sections[0].blocks.reduce((total, block) => {
    return total + block.blockSubtotal;
  }, 0);
  
  const liabilitiesEquityTotal = processedTemplate.sections[1].blocks.reduce((total, block) => {
    return total + block.blockSubtotal;
  }, 0);
  
  const diff = assetsTotal - liabilitiesEquityTotal;
  
  processedTemplate.totals = {
    assetsTotal,
    liabilitiesEquityTotal,
    diff
  };
  
  return processedTemplate;
};

// Helper function to format amount for display
export const formatAmount = (amount) => {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return '0,00 TL';
  }
  
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount) + ' TL';
};

// Validation function to check if all required kebir codes are present
export const validateTDHPStructure = (balanceSheetData) => {
  const requiredCodes = [];
  const missingCodes = [];
  
  // Extract all required kebir codes from template
  balanceSheetData.sections.forEach(section => {
    section.blocks.forEach(block => {
      block.groups.forEach(group => {
        group.lines.forEach(line => {
          requiredCodes.push(line.code);
        });
      });
    });
  });
  
  // Check if all required codes have data (even if zero)
  requiredCodes.forEach(code => {
    const hasData = balanceSheetData.sections.some(section => 
      section.blocks.some(block => 
        block.groups.some(group => 
          group.lines.some(line => line.code === code)
        )
      )
    );
    
    if (!hasData) {
      missingCodes.push(code);
    }
  });
  
  return {
    isValid: missingCodes.length === 0,
    missingCodes,
    requiredCodes: requiredCodes.length
  };
};

// Helper function to validate balance sheet totals with signed balance logic
export const validateBalanceSheetTotals = (balanceSheetData) => {
  if (!balanceSheetData || !balanceSheetData.totals) {
    return {
      isValid: false,
      message: 'Invalid balance sheet data',
      details: 'Missing totals information'
    };
  }
  
  const { assetsTotal, liabilitiesEquityTotal } = balanceSheetData.totals;
  
  // Check if totals are numbers
  if (typeof assetsTotal !== 'number' || typeof liabilitiesEquityTotal !== 'number') {
    return {
      isValid: false,
      message: 'Invalid total values',
      details: 'Total values must be numbers'
    };
  }
  
  // Calculate the difference
  const calculatedDiff = assetsTotal - liabilitiesEquityTotal;
  const tolerance = 0.01; // Allow for small rounding differences
  
  // Check if the balance sheet balances
  if (Math.abs(calculatedDiff) <= tolerance) {
    return {
      isValid: true,
      message: 'Balance sheet is balanced',
      details: `Assets (${assetsTotal.toFixed(2)}) = Liabilities + Equity (${liabilitiesEquityTotal.toFixed(2)})`,
      diff: calculatedDiff
    };
  } else {
    return {
      isValid: false,
      message: 'Balance sheet is not balanced',
      details: `Assets (${assetsTotal.toFixed(2)}) ≠ Liabilities + Equity (${liabilitiesEquityTotal.toFixed(2)}). Difference: ${calculatedDiff.toFixed(2)}`,
      diff: calculatedDiff,
      assetsTotal,
      liabilitiesEquityTotal
    };
  }
};
